module.exports = __webpack_public_path__ + "static/media/red-stamp-wave.a9c14ce9.png";